module.exports = __webpack_public_path__ + "assets/img/wheel_bg.8caee3ee.png";